<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="page_vii"></a><img alt="Image" src="images/f0vii-01.jpg"/></p>
<div class="pagebreak">
<p class="linespace"> </p>
<p class="linespace"> </p>
<blockquote>
<p class="para5"><a id="page_ix"></a>“Guess now who holds thee?”—<br/>“Death,” I said. But there<br/> The silver answer rang—<br/>“Not Death, but Love.”</p>
<p class="para"> </p>
<p class="right-para5">—Elizabeth Barrett Browning,</p>
<p class="right-para5a"><em>Sonnets from the Portuguese</em></p>
</blockquote>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// map.vue?eeb0b9bc